module.exports = {"phase":{"D1":["Basement"],"D2":["Basement"],"D3":["Basement","0","1","2","3","4","5","6","7","Roof"],"D4":["-1","Basement","0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","Roof"],"D5":["Basement","0","1","2","3","4","5","6","7","8","9","Roof"],"D6":["Basement","0","1","2","3","4","5","6","7","8","9","10","11","12","13","Roof"],"D7":["Basement","0","1","2","3","4","5","6","7","8","Roof"],"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/beaufortPark.json
// module id = 111
// module chunks = 0